import * as React from "react";
import { cn } from "../_internal/cn";
import type { TypeAIContainerProps } from "./AIContainerTypes";

/**
 * AIContainer — a rounded surface primitive with the AI gradient background.
 * Provides the outer shell (border-radius, shadow, overflow, gradient) without
 * any padding. Used by PullQuote and available as a standalone container.
 *
 * - `subtle` — a light 20% gradient tint over the base surface with adaptive text color.
 * - `vivid` — the full-saturation AI gradient with white text (always white).
 *
 * Styled via `ai-container.css` (Seeds CSS custom properties).
 */
const AIContainer = React.forwardRef<HTMLDivElement, TypeAIContainerProps>(
  ({ children, appearance = "subtle", className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "seeds-ai-container",
          { "seeds-ai-container-vivid": appearance === "vivid" },
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

AIContainer.displayName = "AIContainer";

export default AIContainer;
